import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronRight, LayoutDashboard, User } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

// Instructor Icons
import Chat from "../../Images/chat.svg";
import ChatWhite from "../../Images/forum_white.svg";
import program from "../../Images/Program.svg";
import program_white from "../../Images/program_white.svg";
import Excersise from "../../Images/Excersise.svg";
import ExcersiseWhite from "../../Images/Excersise.svg";
import Profile from "../../Images/Profile.svg";
import ProfileWhite from "../../Images/MyProfile_white.svg";
import Myprogram from "../../Images/Myprogram.svg";
import Calendar from "../../Images/calendar.svg";
import CalendarWhite from "../../Images/calendar_white.svg";
import Students from "../../Images/Students.svg";
import StudentsWhite from "../../Images/Student_white.svg";
import Review from "../../Images/Review.svg";
import ReviewWhite from "../../Images/Review_white.svg";

// Student Icons
import MyCoursesIcon from "../../Images/programs.svg";
import forum_black from "../../Images/forum_black.svg";
import accumplishment_black from "../../Images/Accomplishment_black.svg";
import accumplishmentIcon from "../../Images/Accomplishment_white.svg";
import myprograms_white from "../../Images/program_white.svg";
import chat_white from "../../Images/Chat_white.svg";
import profile_white from "../../Images/profile_white.svg";
import { API_URL } from "../../config/api";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openProgram, setOpenProgram] = useState(true);

  const [userRole, setUserRole] = useState(() => {
    return localStorage.getItem("userRole") || null;
  });

  const [loading, setLoading] = useState(true);

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          setLoading(false);
          navigate("/");
          return;
        }

        const response = await axios.get(`${API_URL}/current_user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const role = response.data.roles[0]?.name;
        if (role) {
          setUserRole(role);
          localStorage.setItem("userRole", role);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
        localStorage.removeItem("userRole");
        localStorage.removeItem("access_token");
        setUserRole(null);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  const adminRoles = ["super_admin", "org_admin", "training_partner_admin"];
  const isAdminRole = adminRoles.includes(userRole);

  const paths = isAdminRole
    ? {
        profile: "/admin_profile",
        allProgram: "/admin_programs",
        programSchedule: "/admin_program_schedule",
        users: userRole === "super_admin" ? "/user_list" : "/org_user_list",
        students: "/admin_students",
        forum: "/admin_forum",
        review: "/admin_review",
      }
    : {
        profile: "/ins_profile",
        programSchedule: "/program_schdule",
        students: "/ins_student",
        forum: "/ins_forum",
        review: "/ins_student/review",
        allProgram: "/admin_actual",
      };

  const isProgramSubmenuActive = () =>
    isActive("/ins_program") || isActive("/ins_program/exercise");

  const studentMenuItems = [
    {
      name: "Dashboard",
      iconType: "component",
      icon: LayoutDashboard,
      path: "/student_dashboard",
    },
    {
      name: "My Programs",
      iconType: "image",
      icon: MyCoursesIcon,
      activeIcon: myprograms_white,
      path: "/myprograms",
    },
    {
      name: "My Profile",
      iconType: "component",
      icon: User,
      activeIcon: profile_white,
      path: "/student_profile",
    },
    {
      name: "Discussion Form",
      iconType: "image",
      icon: forum_black,
      activeIcon: chat_white,
      path: "/student_forum",
    },
    {
      name: "Accomplishments",
      iconType: "image",
      icon: accumplishment_black,
      activeIcon: accumplishmentIcon,
      path: "/accomplishment",
    },
  ];

  if (loading) {
    return (
      <div className="w-56 bg-white border-r border-gray-200 h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4AACC5] mx-auto mb-2"></div>
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // -----------------------------------------------
  // Instructor + Admin Sidebar
  // -----------------------------------------------
  if (userRole === "instructor" || isAdminRole) {
    return (
      <div className="w-56 bg-white border-r border-gray-200 h-screen flex flex-col">

        {/* My Profile */}
        <button
          onClick={() => navigate(paths.profile)}
          className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
            ${isActive(paths.profile) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
        >
          <img
            src={isActive(paths.profile) ? ProfileWhite : Profile}
            alt="My Profile"
            className="w-5 h-5"
          />
          My Profile
        </button>

        {/* All Program */}
        {isAdminRole ? (
          <button
            onClick={() => navigate(paths.allProgram)}
            className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
              ${isActive(paths.allProgram) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
          >
            <img
              src={isActive(paths.allProgram) ? program_white : program}
              alt="All Program"
              className="w-5 h-5"
            />
            All Program
          </button>
        ) : (
          <>
            <button
              onClick={() => setOpenProgram(!openProgram)}
              className={`flex items-center justify-between px-4 h-12 text-sm font-medium transition-colors
                ${isProgramSubmenuActive() ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
            >
              <div className="flex items-center gap-3">
                <img
                  src={isProgramSubmenuActive() ? program_white : program}
                  alt="Program"
                  className="w-5 h-5"
                />
                Program
              </div>
              {openProgram ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </button>

            {openProgram && (
              <div className="ml-6 flex flex-col">
                {[
                  { name: "My Program", icon: Myprogram, path: "/ins_program" },
                  { name: "Exercise", icon: Excersise, activeIcon: ExcersiseWhite, path: "/ins_program/exercise" },
                ].map((item) => (
                  <button
                    key={item.path}
                    onClick={() => navigate(item.path)}
                    className={`flex items-center gap-3 px-4 h-10 text-sm rounded-r-lg transition-colors
                      ${isActive(item.path) ? "bg-[#DDF3F8] text-[#4AACC5]" : "text-gray-600 hover:bg-gray-100"}`}
                  >
                    <img
                      src={isActive(item.path) && item.activeIcon ? item.activeIcon : item.icon}
                      alt={item.name}
                      className="w-4 h-4"
                    />
                    {item.name}
                  </button>
                ))}
              </div>
            )}
          </>
        )}

        {/* Program Schedule */}
        <button
          onClick={() => navigate(paths.programSchedule)}
          className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
            ${isActive(paths.programSchedule) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
        >
          <img
            src={isActive(paths.programSchedule) ? CalendarWhite : Calendar}
            alt="Program Schedule"
            className="w-5 h-5"
          />
          Program Schedule
        </button>

        {/* Users — Admin only */}
        {isAdminRole && (
          <button
            onClick={() => navigate(paths.users)}
            className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
              ${isActive(paths.users) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
          >
            <img
              src={isActive(paths.users) ? StudentsWhite : Students}
              alt="Users"
              className="w-5 h-5"
            />
            Users
          </button>
        )}

        {/* Students */}
        <button
          onClick={() => navigate(paths.students)}
          className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
            ${isActive(paths.students) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
        >
          <img
            src={isActive(paths.students) ? StudentsWhite : Students}
            alt="Students"
            className="w-5 h-5"
          />
          Students
        </button>

        {/* Discussion Forum */}
        <button
          onClick={() => navigate(paths.forum)}
          className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
            ${isActive(paths.forum) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
        >
          <img
            src={isActive(paths.forum) ? ChatWhite : Chat}
            alt="Discussion Forum"
            className="w-5 h-5"
          />
          Discussion Forum
        </button>

        {/* Review and Rating */}
        <button
          onClick={() => navigate(paths.review)}
          className={`flex items-center gap-3 px-4 h-12 text-sm font-medium transition-colors
            ${isActive(paths.review) ? "bg-[#4AACC5] text-white" : "text-gray-700 hover:bg-gray-100"}`}
        >
          <img
            src={isActive(paths.review) ? ReviewWhite : Review}
            alt="Review and Rating"
            className="w-5 h-5"
          />
          Review and Rating
        </button>

      </div>
    );
  }

  // -----------------------------------------------
  // Student Sidebar
  // -----------------------------------------------
  return (
    <aside className="w-56 bg-white min-h-screen border-r shadow-sm">
      {studentMenuItems.map((item, i) => {
        const isActiveItem = isActive(item.path);
        return (
          <div
            key={i}
            onClick={() => navigate(item.path)}
            className={`h-12 flex items-center gap-3 px-6 border-b cursor-pointer transition-colors
              ${isActiveItem ? "bg-[#4AACC5] text-white font-semibold" : "hover:bg-gray-50 text-gray-700"}`}
          >
            {item.iconType === "component" ? (
              <item.icon size={18} color={isActiveItem ? "white" : "#374151"} />
            ) : (
              <img
                src={isActiveItem ? item.activeIcon : item.icon}
                alt={item.name}
                className="w-5 h-5"
              />
            )}
            <span className="text-sm">{item.name}</span>
          </div>
        );
      })}
    </aside>
  );
};

export default Sidebar;